import styled from 'styled-components';

import ActionButton from 'components/action-button';
import Link from 'components/link';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';

import { LoyaltyLoader } from '../loyalty-loader';

export const LoadingAnimation = styled(LoyaltyLoader)`
  height: calc(100% - 6.5rem);
  position: absolute;
  width: 100%;
`;

export const DesktopBackButton = styled(ActionButton)`
  position: absolute;
  left: 3rem;
  top: 7rem;
  color: ${p => p.theme.token('text-button-secondary')};
  border: solid 2px ${p => p.theme.token('border-color-button-secondary')};
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  padding: 0.675rem 1.375rem;
  line-height: 0.75rem;
`;

export const MainImage = styled(Picture)`
  max-width: 12.5rem;
  margin: auto;
`;

const TextBlock = styled(SanityBlockRenderer)`
  p {
    font-size: 0.9375rem;
    line-height: 1.3125rem;
  }
`;

export const Text = styled(TextBlock)`
  p {
    text-align: center;
  }
`;

export const InstructionDateText = TextBlock;

export const Title = styled.h2`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.5rem;
  line-height: 1.5rem;
  margin: 0;
  text-align: center;
`;

export const Button = styled(ActionButton)`
  padding: 0.6875rem 3.75rem;
  margin: 0 1.25rem;
`;

export const StyledLink = styled(Link)`
  display: flex;
  color: ${Styles.color.red};
  text-decoration: underline;
  svg {
    margin-right: 0.5rem;
  }
`;

export const TransactionInputFormContainer = styled.div`
  display: flex;
  justify-content: center;
  grid-gap: 0.75rem;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const TransactionDateInputFormContainer = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 2.5rem;

  ${InstructionDateText} {
    margin-bottom: 0.5rem;
  }
`;

export const EarnedPointsWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0.5rem 0 1.5rem;

  svg {
    margin: 0 0.25rem 0 0.5rem;
  }

  span {
    font-family: ${Styles.fontFamily.brand};
    font-size: 1.125rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 31rem;
  margin: auto;
  padding: 0 1rem;

  ${Styles.desktop`
    margin: 10rem auto 2rem;
  `};

  ${Text},
  ${Title},
  ${Button},
  ${StyledLink},
  ${TransactionInputFormContainer} {
    margin-bottom: 1rem;
  }
  ${MainImage} {
    margin-bottom: 1rem;
    img {
      object-fit: contain;
    }
  }
`;
